/**
 * 各种权限接口
 */
import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const auth = {
	/**
	 * 获取所有权限列表
	 */
	getPermissionList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.uc}/UCenter/RBAC/getPermissions`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 获取权限树状列表
	 */
	getPermissionTreeList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.uc}/UCenter/RBAC/permissions`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 添加权限
	 */
	addPermission(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.uc}/UCenter/RBAC/addPermission`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 删除权限
	 */
	removePermission(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.uc}/UCenter/RBAC/removePermissionById`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取角色树状列表
	 */
	getRolesTreeList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.uc}/UCenter/RBAC/roles`,
			headers: config.headers,
			params
		});
	},
	getRolesList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.uc}/UCenter/RBAC/getRoles`,
			headers: config.headers,
			params
		});
	},
	addRole(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.uc}/UCenter/RBAC/addRole`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 删除角色
	 */
	removeRole(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.uc}/UCenter/RBAC/removeRoleById`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	}
};

export default auth;
